import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("figure", null, [
    (_ctx.isBelow50)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " < "))
      : _createCommentVNode("v-if", true),
    _createTextVNode(" " + _toDisplayString(_ctx.displayScore.score) + "% ", 1 /* TEXT */)
  ]))
}